import { isEmpty, pickBy } from 'lodash';
import { UseFormReturn } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { updateExpense } from 'store/v1/expenses/expenses.actions';
import { updateBudgetExpense } from 'store/v1/productions/productions.actions';
import { isFieldOrParentDirty } from 'v5/platform/react/useDirtyFields';
import { ExpenseEntity, ExpenseEntitySpec } from '../types';

export function useUpdateExpenseEntity(spec: ExpenseEntitySpec) {
  const dispatch = useDispatch();

  return async (form: UseFormReturn<ExpenseEntity>) => {
    const payload = form.getValues();

    if (form.formState.dirtyFields.estimateValue) {
      const changedRateFields: Partial<ExpenseEntity['estimateValue']['rate']> =
        pickBy(payload.estimateValue.rate, (value, field) =>
          isFieldOrParentDirty(
            form.formState.dirtyFields,
            `estimateValue.rate.${field}`
          )
        );

      const budgetExpensePayload = pickBy(
        {
          estimate_rate_amount: changedRateFields.amount,
          estimate_rate_currency: changedRateFields.currency,
          estimate_rate_interval: changedRateFields.interval,
          estimate_rate_quantity: changedRateFields.quantity
        },
        value => value !== undefined
      );

      if (!isEmpty(budgetExpensePayload)) {
        await dispatch(
          updateBudgetExpense(
            {
              production_id: spec.productionId,
              budget_expense_id: spec.slotId
            },
            budgetExpensePayload
          )
        );
      }
    }

    if (
      form.formState.dirtyFields.actualValue &&
      payload.actualValue &&
      spec.expenseId
    ) {
      const changedRateFields = pickBy(
        payload.actualValue.rate,
        (value, field) =>
          isFieldOrParentDirty(
            form.formState.dirtyFields,
            `actualValue.rate.${field}`
          )
      );

      const expensePayload = pickBy(
        {
          commit_rate_amount: changedRateFields.amount,
          commit_rate_currency: changedRateFields.currency,
          commit_rate_interval: changedRateFields.interval,
          commit_rate_quantity: changedRateFields.quantity
        },
        value => value !== undefined
      );

      if (!isEmpty(expensePayload)) {
        await dispatch(updateExpense(spec.expenseId, expensePayload));
      }
    }
  };
}
